import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../../components/Icon";
import { showSuccess, showError } from "../../../../services/toast.service";

const Panel = ({ selectedPromotions = [], onDeleteSelected, onClearSelection, onDuplicateSelected }) => {
  const handleDeleteSelected = async () => {
    if (!selectedPromotions.length) return;
    
    try {
      await onDeleteSelected(selectedPromotions);
      showSuccess(`${selectedPromotions.length} promotion(s) supprimée(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des promotions');
      console.error(error);
    }
  };
  
  const handleDuplicateSelected = async () => {
    if (!selectedPromotions.length) return;
    
    try {
      await onDuplicateSelected(selectedPromotions);
      showSuccess(`${selectedPromotions.length} promotion(s) dupliquée(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la duplication des promotions');
      console.error(error);
    }
  };

  // Ne pas afficher le panel s'il n'y a pas de promotions sélectionnées
  if (!selectedPromotions.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedPromotions.length} promotion{selectedPromotions.length > 1 ? 's' : ''} sélectionnée{selectedPromotions.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke", styles.button)} onClick={handleDuplicateSelected}>
          <Icon name="copy" size="24" />
          <span>Dupliquer</span>
        </button>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleDeleteSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
